import * as graphql from '@treams/treams-network';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'clientID') {
		return {
			title: 'API Key',
			description: 'Vul de API key in die je van Visma hebt ontvangen.',
		};
	}

	if (key === 'clientSecret') {
		return {
			title: 'API Secret',
			description: 'Vul de API secret in die je van Visma hebt ontvangen.',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

export default function YouForce() {
	return (
		<ProductLayout
			id="youforce"
			type={graphql.ConnectorType.Youforce}
			headerImageURL="https://assets.ontreams.com/marketplace/youforce-wide.jpg"
			translate={translate}
		/>
	);
}

export function YouForceTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="youforce"
			title="YouForce"
			description="Maak het HR-leven makkelijker met YouForce."
			logoImageURL="https://assets.ontreams.com/marketplace/youforce.jpg"
			selected={props.selected}
		/>
	);
}
